import React from 'react'
import Bloglandingpage from '../../Blogs/bloglandingpage'
import Footer from '../Home/footer/Footer'

function Blogs() {
  return (
    <div>
      <Bloglandingpage/>
      <Footer/>
    </div>
  )
}

export default Blogs